import React from "react";
import { ButtonBase, Stack, Typography } from "@mui/material";
import ColoredIcon from "./ColoredIcon";
import BackIcon from "../img/Arrow_Left.svg";
import { useNavigate } from "react-router-dom";
import { FONTS } from "../constants/styles";

interface Props {
    name: string;
    onClick?: () => void;
    disabled?: boolean;
    noBackIcon?: boolean;
    actions?: React.ReactNode; // Optional action buttons/icons
}

const TabHeader = (props: Props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { name, onClick, disabled, noBackIcon = false, actions } = props;

    const navigate = useNavigate();

    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            width="100%"
            //height="48px"
            minHeight="48px"
            maxHeight="88px"
            position="relative"
        >
            {!noBackIcon && (
                <ButtonBase
                    onClick={() => navigate(-1 || "/")}
                    disabled={disabled}
                    sx={{ position: "absolute", left: "6px" }}
                >
                    <ColoredIcon icon={BackIcon} color="black" size="38px" />
                </ButtonBase>
            )}
            <Typography
                fontWeight={600}
                fontSize="18px"
                lineHeight="23.4px"
                textAlign="center"
                fontFamily={FONTS.display}
                px={6}
                py={1}
            >
                {name}
            </Typography>
            {actions && (
                <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ position: "absolute", right: "15px" }}
                >
                    {actions}
                </Stack>
            )}
        </Stack>
    );
};

export default TabHeader;
